//export const API_BASE = "http://157.230.56.58:8096";
// export const API_BASE = "http://localhost:8096";
//export const API_BASE = "http://mkzrakitna.guvenfuture.com";
export const API_BASE = "https://gamebackend.networklaws.com";

//"https://apistage.onedose.io";